import { createGlobalStyle } from 'styled-components';
import { theme } from '../config/theme';

export const GlobalStyles = createGlobalStyle`

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
    background-color: ${theme.colors.primary.background};
  }

  body {
    font-family: ${theme.typography.secondary.fontFamily};
    font-size: ${theme.typography.secondary.body.fontSize};
    font-weight: ${theme.typography.secondary.body.fontWeight};
    line-height: ${theme.typography.secondary.body.lineHeight};
    color: ${theme.colors.primary.text};
    background-color: ${theme.colors.primary.background};
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${theme.typography.primary.fontFamily};
    font-weight: ${theme.typography.primary.heading.fontWeight};
    line-height: ${theme.typography.primary.heading.lineHeight};
    color: ${theme.colors.primary.text};
  }

  h1 {
    font-size: ${theme.typography.primary.heroTitle.fontSize};
    line-height: ${theme.typography.primary.heroTitle.lineHeight};
  }

  h2 {
    font-size: ${theme.typography.primary.heading.fontSize};
  }

  a {
    text-decoration: none;
    color: inherit;
    transition: ${theme.transitions.default};
  }

  button {
    font-family: ${theme.typography.secondary.fontFamily};
    cursor: pointer;
    border: none;
    outline: none;
    transition: ${theme.transitions.default};
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  ::selection {
    background-color: ${theme.colors.accent.main};
    color: ${theme.colors.neutral.lightest};
  }

  /* Anchor offset for fixed navigation - uses dynamic height */
  *[id] {
    scroll-margin-top: var(--nav-height, 128px);
  }
`;